// extracted by mini-css-extract-plugin
export var conversationListItem = "_wm-2";
export var fullBleedList = "_wm-3";
export var messageText = "_wm-1";
export var previewText = "_wm-0";